module.exports = __webpack_public_path__ + "6c4a0dbc/img/copy-icon.408fdb2d.svg";